import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers } from "vue"

import { ref } from 'vue';
import { register } from '@/services/auth/auth.service';
import type { RegisterPayload } from '@/services/auth/auth.model';
import { useAuthStore } from '@/stores/auth';


export default /*@__PURE__*/_defineComponent({
  __name: 'AddUser',
  setup(__props) {

const login = ref('');
const email = ref('');
const password = ref('');
const repeatPassword = ref('');
const loading = ref(false);
const errorMessage = ref('');
const successMessage = ref('');

const auth = useAuthStore();

const handleSubmit = async () => {
  errorMessage.value = '';
  successMessage.value = '';

  if (!login.value || !email.value || !password.value || !repeatPassword.value) {
    errorMessage.value = 'Please fill in all fields.';
    return;
  }

  loading.value = true;
  try {
    const payload: RegisterPayload = {
      login: login.value,
      email: email.value,
      password: password.value,
      repeatPassword: repeatPassword.value,
    };

    const token = auth.getToken;
    if (!token) {
      throw new Error('You must be logged in to add a new user.');
    }

    await register(payload);
    successMessage.value = 'User created successfully.';
  } catch (err: any) {
    errorMessage.value = err?.message || 'Failed to create user.';
  } finally {
    loading.value = false;
  }
};

return (_ctx: any,_cache: any) => {
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_alert = _resolveComponent("v-alert")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_form = _resolveComponent("v-form")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_container = _resolveComponent("v-container")!

  return (_openBlock(), _createBlock(_component_v_container, { class: "fill-height d-flex align-center justify-center" }, {
    default: _withCtx(() => [
      _createVNode(_component_v_card, {
        class: "pa-6",
        width: "400"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_card_title, { class: "text-h5 text-center mb-4" }, {
            default: _withCtx(() => [...(_cache[4] || (_cache[4] = [
              _createTextVNode("Add New User", -1)
            ]))]),
            _: 1
          }),
          _createVNode(_component_v_card_text, null, {
            default: _withCtx(() => [
              _createVNode(_component_v_form, {
                onSubmit: _withModifiers(handleSubmit, ["prevent"])
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_text_field, {
                    modelValue: login.value,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((login).value = $event)),
                    label: "Login",
                    "prepend-inner-icon": "mdi-account",
                    outlined: "",
                    required: ""
                  }, null, 8, ["modelValue"]),
                  _createVNode(_component_v_text_field, {
                    modelValue: email.value,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((email).value = $event)),
                    label: "Email",
                    "prepend-inner-icon": "mdi-email",
                    outlined: "",
                    required: ""
                  }, null, 8, ["modelValue"]),
                  _createVNode(_component_v_text_field, {
                    modelValue: password.value,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((password).value = $event)),
                    label: "Password",
                    type: "password",
                    "prepend-inner-icon": "mdi-lock",
                    outlined: "",
                    required: ""
                  }, null, 8, ["modelValue"]),
                  _createVNode(_component_v_text_field, {
                    modelValue: repeatPassword.value,
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((repeatPassword).value = $event)),
                    label: "Repeat Password",
                    type: "password",
                    "prepend-inner-icon": "mdi-lock-check",
                    outlined: "",
                    required: ""
                  }, null, 8, ["modelValue"]),
                  (errorMessage.value)
                    ? (_openBlock(), _createBlock(_component_v_alert, {
                        key: 0,
                        type: "error",
                        variant: "tonal",
                        class: "mt-2"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(errorMessage.value), 1)
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true),
                  (successMessage.value)
                    ? (_openBlock(), _createBlock(_component_v_alert, {
                        key: 1,
                        type: "success",
                        variant: "tonal",
                        class: "mt-2"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(successMessage.value), 1)
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true),
                  _createVNode(_component_v_btn, {
                    loading: loading.value,
                    type: "submit",
                    color: "primary",
                    block: "",
                    class: "mt-4"
                  }, {
                    default: _withCtx(() => [...(_cache[5] || (_cache[5] = [
                      _createTextVNode(" Add User ", -1)
                    ]))]),
                    _: 1
                  }, 8, ["loading"])
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})